import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import DonationForm, {
	IDonationFormProps,
} from '../DonorTool/DonorToolComponents/DonationForm';

export interface IRegionHeroBannerProps extends IBaseElementProps {
	regionHeading?: string;
	regionTagline?: string;
	regionDescription?: string;
	regionLinkURL?: string;
	regionLinkLabel?: string;
	backgroundImage?: IImage;
	donationFormProps?: IDonationFormProps;
}

const RegionHeroBanner: React.FC<IRegionHeroBannerProps> = ({
	className,
	classNames = [],
	regionHeading,
	regionTagline,
	regionDescription,
	regionLinkURL,
	regionLinkLabel,
	backgroundImage,
	donationFormProps,
}) => (
	<div className={className || cn('region-hero-banner', ...classNames)}>
		<div className="theme-hero-banner">
			<div className="banner-style-option-2">
				<div className="container-fluid">
					<div className="row">
						<div className="hero-banner__background-overlay" />
						<div
							className={cn('hero-banner__background-image')}
							style={
								backgroundImage
									? {
											backgroundImage: `url("${backgroundImage.src}")`,
									  }
									: {}
							}
						/>
						<div className="col-12 col-lg-5 col-xxl-6 col-lg-left">
							<div className="hero-banner__content">
								{regionHeading && (
									<h1 className="hero-banner__heading">
										{regionHeading}
									</h1>
								)}
								{regionTagline && (
									<p className="hero-banner__tagline">
										{regionTagline}
									</p>
								)}
								{regionDescription && (
									<p className="hero-banner__description">
										{regionDescription}
									</p>
								)}

								{regionLinkURL && regionLinkLabel  && (
									<div className="hero-banner__link">
										<a href={regionLinkURL}>
											{regionLinkLabel}
											<span className="hero-banner__arrow"></span>
										</a>
									</div>
								)}
							</div>
						</div>
						{ donationFormProps &&
							<div className="col-12 col-lg-7 col-xxl-6 col-lg-right">
								<DonationForm {...donationFormProps} hideProgramInformation />
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default RegionHeroBanner;
